const t = "styles-module__container___rUZHp", e = {
  container: t
};
export {
  t as container,
  e as default
};
